// Year — controlled vocabulary for an artwork's year. The enum value
// happens to equal the display string, but keeping the *_DISPLAY map uniform lets the
// UI format years consistently without special-casing.
export enum Year {
    Y2022 = '2022',
    Y2023 = '2023',
    Y2024 = '2024',
    Y2025 = '2025',
    Y2026 = '2026',
}

export const YEAR_DISPLAY: Record<Year, string> = {
    [Year.Y2022]: '2022',
    [Year.Y2023]: '2023',
    [Year.Y2024]: '2024',
    [Year.Y2025]: '2025',
    [Year.Y2026]: '2026',
};
